import React from 'react';
// import PropTypes from 'prop-types';

export default function GroupAlerts() {
  return (
    <div className="alert-group-alerts">
      Component content: alert/GroupAlerts
    </div>
  );
};

GroupAlerts.propTypes = {};
GroupAlerts.defaultProps = {};

GroupAlerts.displayName = 'GroupAlerts'
